import React, { useEffect, useState } from "react";

//MUI
import { Box, Button, Divider, Stack, Grid, Typography } from "@mui/material";
import UTextField from "../../components/mui/UTextField";

import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import { getAPI} from "../../services/commonService";


import UTable from "../../components/mui/UTable";

import AuthenticationService from "../auth/AuthenticationService";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { theme } from '../../assets/themes';
import { makeStyles } from "@material-ui/core/styles";
import UDatePickers from "../../components/mui/UDatePickers";


export default function VaultPopUpPage(props){
	
    const isUserId = AuthenticationService.getLoggedInUserID();
	// const searchParams = new URLSearchParams(window.location.search);
    // const params = {
        //     storeCd: searchParams.get("storeCd"),
        //     startDate: searchParams.get("startDate"),
        //     endDate: searchParams.get("endDate"),
        //     pageNum: searchParams.get("pageNum"),
        //     machId: searchParams.get("machId"),
        // };
    const searchParams = props.data;
    const params = {
        storeCd: searchParams.storeCd,
        machId: searchParams.machId,
        startDate: searchParams.startDate,
        endDate: searchParams.endDate,
        pageNum: searchParams.pageNum,
    };
    
    let date = new Date(); 
    if(searchParams.startDate&&searchParams.startDate.length>=8){
        date = new Date(searchParams.startDate);
    };
    const dateNow = date.toISOString().slice(0, 10); 
    let dateTmp = date; 
    dateTmp.setDate(dateTmp.getDate() - 7);
    const dateNow2 = dateTmp.toISOString().slice(0, 10); 

    const [search, setSearch] = useState({
        //pageNum: "1"
        pageNum: searchParams.pageNum
        ,storeCd: searchParams.storeCd
        ,machId: searchParams.machId
        ,startDate: dateNow2
        ,endDate: dateNow
        //,brandCd: "N/A"
    });

    const [stores, setStores] = useState([]);
    const [rows, setRows] = useState([]);
    
    const columns = [
        // { 
        //     field: 'id',
        //     headerName: 'No',
        //     width: 50,
        //     align: "center",
        //     headerAlign: "center",
        // },
        {
            field: 'finalDateTime',
            headerName: '마감일자',
            width: 180,
            align: "center",
            headerAlign: "center",
            id:"1"
        },
        {
            field: 'machId',
            headerName: '기기번호',
            width: 120,
            align: "center",
            headerAlign: "center",
            id:"2",
            hide: true,
        },
        {
            field: 'fnsetTyNm',
            headerName: '거래유형',
            width: 110,
            align: "center",
            headerAlign: "center",
            id:"3"
        },
        {
            field: 'totalBill',
            headerName: '지폐 매수',
            width: 100,
            align: "center",
            headerAlign: "center",
            id:"4",
            colSpan: [
                {
                    parentField: "totalBill",
                    field: 'usdBill100Cnt',
                    headerName: '$100',
                    // width: 50,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    parentField: "totalBill",
                    field: 'usdBill50Cnt',
                    headerName: '$50',
                    // width: 50,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    parentField: "totalBill",
                    field: 'usdBill20Cnt',
                    headerName: '$20',
                    // width: 50,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    parentField: "totalBill",
                    field: 'usdBill10Cnt',
                    headerName: '$10',
                    // width: 50,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    parentField: "totalBill",
                    field: 'usdBill5Cnt',
                    headerName: '$5',
                    // width: 50,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                /* 주석 처리 by 화면설계서v1.6
                {
                    field: 'usdBill2Cnt',
                    headerName: '$2',
                    width: 50,
                    align: "right",
                    headerAlign: "center",
                },
                */
                {
                    parentField: "totalBill",
                    field: 'usdBill1Cnt',
                    headerName: '$1',
                    // width: 50,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return Number(params.value).toLocaleString('en-US');
                    }
                },
                {
                    //field: 'usdBillTotalCnt', //**TODO bill sub total 추가 */
                    parentField: "totalBill",
                    field: 'totalBillCnt',
                    headerName: '합계',
                    width: 110,
                    align: "right",
                    headerAlign: "center",
                    /*valueFormatter: (params)=>{
                        if (params.value == null) {
                            return '0';
                        }
                        return "$"+Number(params.value).toLocaleString('en-US');
                    }*/
                },
            ],
        },
        //**TODO coin 1 -> in? out? 
        /*
        {
            field: 'totalInCoinCnt',
            headerName: 'Coin (Count)',
            width: 100,
            align: "center",
            headerAlign: "center",
            id:"5",
            colSpan: [
                {
                    field: 'usdInCoin25Cnt',
                    headerName: '25¢',
                    width: 50,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    field: 'usdInCoin10Cnt',
                    headerName: '10¢',
                    width: 50,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    field: 'usdInCoin5Cnt',
                    headerName: '5¢',
                    width: 50,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    field: 'usdInCoin1Cnt',
                    headerName: '1¢',
                    width: 50,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    field: 'usdInCoinTotalCnt',
                    headerName: 'Total',
                    width: 150,
                    align: "right",
                    headerAlign: "center",
                },
            ]
        },
        */
        {
            field: 'totalOutCoin',
            headerName: '동전출금 / 동전입금 (갯수)',
            width: 100,
            align: "center",
            headerAlign: "center",
            id:"6",
            colSpan: [
                /* 주석 처리 by 화면설계서v1.6
                {
                    field: 'usdOutCoin100Cnt',
                    headerName: '100¢',
                    width: 50,
                    align: "right",
                    headerAlign: "center",
                },
                {
                    field: 'usdOutCoin50Cnt',
                    headerName: '50¢',
                    width: 50,
                    align: "right",
                    headerAlign: "center",
                },
                */
                {
                    parentField: "totalOutCoin",
                    field: 'usdInOutCoin100Cnt',
                    headerName: '100₵',
                    // width: 40,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },
                {
                    parentField: "totalOutCoin",
                    field: 'usdInOutCoin50Cnt',
                    headerName: '50₵',
                    // width: 40,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },
                {
                    parentField: "totalOutCoin",
                    field: 'usdInOutCoin25Cnt',
                    headerName: '25₵',
                    // width: 40,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                }, 
                {
                    parentField: "totalOutCoin",
                    field: 'usdInOutCoin10Cnt',
                    headerName: '10₵',
                    // width: 40,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },  
                {
                    parentField: "totalOutCoin",
                    field: 'usdInOutCoin5Cnt',
                    headerName: '5₵',
                    // width: 40,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },   
                {
                    parentField: "totalOutCoin",
                    field: 'usdInOutCoin1Cnt',
                    headerName: '1₵',
                    // width: 40,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var inOutCoin = params.value.split(",");
                        if(Number(inOutCoin[0]) != 0 && !isNaN(inOutCoin[0])) {
                            inOutCoin[0] = Number(inOutCoin[0]).toLocaleString('en-US');
                        } else inOutCoin[0] = 0;
                        if(Number(inOutCoin[1]) != 0 && !isNaN(inOutCoin[1]) ) {
                            inOutCoin[1] = Number(inOutCoin[1]).toLocaleString('en-US')
                        } else inOutCoin[1] = 0;
                        return (
                            <>
                                {inOutCoin[0]}
                                <br />
                                {inOutCoin[1]}
                            </>
                        );
                    }
                },
                {
                    //field: 'usdOutCoinTotalCnt',//**TODO coin sub total 추가 */
                    parentField: "totalOutCoin",
                    field: 'InoutCoinTotCnt',
                    headerName: '합계',
                    width: 110,
                    editable: false,
                    align: "right",
                    headerAlign: "center",
                    valueFormatter: (params)=>{
                        var totCnt = params.value.split(",");
                        
                        if(Number(totCnt[0]) != 0 ) {
                            totCnt[0] = "$"+Number(totCnt[0]).toLocaleString("en-US");
                        } else totCnt[0] = 0;
                        if(Number(totCnt[1]) != 0 ) {
                            totCnt[1] ="$"+Number(totCnt[1]).toLocaleString("en-US")
                        } else totCnt[1] = 0;
                        return (
                            <>
                                {totCnt[0]}
                                <br />
                                {totCnt[1]}
                            </>
                        );
                    }
                }
            ]
        },
        {
            field: 'rejtAmnt',//**TODO bill+coin total 추가 */
            headerName: '리젝함',
            // width: 80,
            align: "right",
            headerAlign: "center",
            id:"7",
            /*valueFormatter: (params)=>{
                if (params.value == null) {
                    return '0';
                }
                return "$"+Number(params.value).toLocaleString('en-US');
            }*/
        },
        {
            field: 'envelopeAmnt',//**TODO bill+coin total 추가 */
            headerName: '봉투입금함',
            // width: 80,
            align: "right",
            headerAlign: "center",
            id:"7",
            /*valueFormatter: (params)=>{
                if (params.value == null) {
                    return '0';
                }
                return "$"+Number(params.value).toLocaleString('en-US');
            }*/
        },
        {
            field: 'transitcstAmnt',//**TODO bill+coin total 추가 */
            headerName: '보회함',
            // width: 80,
            align: "right",
            headerAlign: "center",
            id:"7",
            /*valueFormatter: (params)=>{
                if (params.value == null) {
                    return '0';
                }
                return "$"+Number(params.value).toLocaleString('en-US');
            }*/
        },
        {
            field: 'totalAmount',//**TODO bill+coin total 추가 */
            headerName: '총합 계',
            width: 120,
            align: "right",
            headerAlign: "center",
            id:"7",
            /*valueFormatter: (params)=>{
                if (params.value == null) {
                    return '0';
                }
                return "$"+Number(params.value).toLocaleString('en-US');
            }*/
        },
        //리젝함 불명권 매수
        {
            field: 'rejtUnkcnt', //**TODO 추가 컬럼
            headerName: '리젝함 불명권 매수',
            // width: 40,
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.value > 0) {
                return (
                    <div
                    style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "red",
                    }}
                    >
                    {params.value}
                    </div>
                );
                }
                return params.value;
            }
        },
        /* 주석 처리 by 화면설계서v1.6
        {
            field: 'inBillboxCnt',
            headerName: '추가입금함잔량',
            width: 150,
            align: "right",
            headerAlign: "center",
            id:"7"
        },
        {
            field: 'outRejtCnt',
            headerName: '출금리젝함잔량',
            width: 150,
            align: "right",
            headerAlign: "center",
            id:"8"
        },
        {
            field: 'inBillboxAmt',
            headerName: '추가입금함금액',
            width: 150,
            align: "right",
            headerAlign: "center",
            id:"9"
        },
        {
            field: 'outRejtAmt',
            headerName: '출금리젝함금액',
            width: 150,
            align: "right",
            headerAlign: "center",
            id:"10"
        },
        */
    ];

    const useStyles = makeStyles({
        table: {
            "& .MuiTableCell-root": {
                border: "1px solid #EAEAEA",
                borderTop: "1px solid #EAEAEA",
            }
        },
        header:{
            fontWeight:"bold",
            "& .MuiTableCell-root": {
                // width:195,
            }
        },
        cellTitle:{
            backgroundColor:theme.custom.appbarBgColor,            
        },
        cell:{
            padding:5
        }
    });
    const classes = useStyles();

	//화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
            try {
                await loadDetailInfo(search);
            } catch (e) {
                console.log(e.message);
            }
        };
        getLoadData();
    }, [search]);

    const loadDetailInfo = async(params) => {
        try {
            await getAPI(API.CASH.VAULT_HIST, params).then((res)=>{
                // console.log(">> response : ", res);
                const _inputData = res.data.result.map((rowData) => ({
                    id: rowData.id,
                    saleDateTime: rowData.saleDateTime,
                    storeCd: rowData.storeCd,
                    machId: rowData.machId,
                    fnsetTy: rowData.fnsetTy,
                    fnsetTyNm: rowData.fnsetTyNm,
                    finalDateTime: rowData.finalDateTime,
                    totalBillCnt: isNaN(rowData.totalBillCnt)?"0":"$"+Number(rowData.totalBillCnt).toLocaleString("en-US"),
                    usdBill100Cnt: rowData.usdBill100Cnt,
                    usdBill50Cnt: rowData.usdBill50Cnt,
                    usdBill20Cnt: rowData.usdBill20Cnt,
                    usdBill10Cnt: rowData.usdBill10Cnt,
                    usdBill5Cnt: rowData.usdBill5Cnt,
                    usdBill2Cnt: rowData.usdBill2Cnt,
                    usdBill1Cnt: rowData.usdBill1Cnt,
                    totalInCoinCnt: isNaN(rowData.totalInCoinCnt)?"0":"$"+Number(rowData.totalInCoinCnt).toLocaleString("en-US"),
                    usdInCoin100Cnt: rowData.usdInCoin100Cnt,
                    usdInCoin50Cnt: rowData.usdInCoin50Cnt,
                    usdInCoin25Cnt: rowData.usdInCoin25Cnt,
                    usdInCoin10Cnt: rowData.usdInCoin10Cnt,
                    usdInCoin5Cnt: rowData.usdInCoin5Cnt,
                    usdInCoin1Cnt: rowData.usdInCoin1Cnt,
                    totalOutCoinCnt: isNaN(rowData.totalOutCoinCnt)?"0":"$"+Number(rowData.totalOutCoinCnt).toLocaleString("en-US"),
                    usdOutCoin100Cnt: rowData.usdOutCoin100Cnt,
                    usdOutCoin50Cnt: rowData.usdOutCoin50Cnt,
                    usdOutCoin25Cnt: rowData.usdOutCoin25Cnt,
                    usdOutCoin10Cnt: rowData.usdOutCoin10Cnt,
                    usdOutCoin5Cnt: rowData.usdOutCoin5Cnt,
                    usdOutCoin1Cnt: rowData.usdOutCoin1Cnt,
                    inBillboxCnt: rowData.inBillboxCnt,
                    outRejtCnt: rowData.outRejtCnt,
                    inBillboxAmt: rowData.inBillboxAmt,
                    outRejtAmt: rowData.outRejtAmt,
                    usdInOutCoin100Cnt: rowData.usdOutCoin100Cnt +"," + rowData.usdInCoin100Cnt,
                    usdInOutCoin50Cnt: rowData.usdOutCoin50Cnt +"," + rowData.usdInCoin50Cnt,
                    usdInOutCoin25Cnt: rowData.usdOutCoin25Cnt +"," + rowData.usdInCoin25Cnt,
                    usdInOutCoin10Cnt: rowData.usdOutCoin10Cnt +"," + rowData.usdInCoin10Cnt,
                    usdInOutCoin5Cnt : rowData.usdOutCoin5Cnt +"," + rowData.usdInCoin5Cnt,
                    usdInOutCoin1Cnt: rowData.usdOutCoin1Cnt + "," + rowData.usdInCoin1Cnt,
                    InoutCoinTotCnt: rowData.totalOutCoinCnt + "," + rowData.totalInCoinCnt,
                    rejtAmnt: isNaN(rowData.rejtAmnt)?"0":"$"+Number(rowData.rejtAmnt).toLocaleString("en-US"),
                    envelopeAmnt: isNaN(rowData.envelopeAmnt)?"0":"$"+Number(rowData.envelopeAmnt).toLocaleString("en-US"),
                    transitcstAmnt: isNaN(rowData.transitcstAmnt)?"0":"$"+Number(rowData.transitcstAmnt).toLocaleString("en-US"),    
                    totalAmount: isNaN(rowData.totalAmount)?"0":"$"+Number(rowData.totalAmount).toLocaleString("en-US"),
                    rejtUnkcnt: rowData.rejtUnkcnt,
                }));
                setRows(_inputData);
                //setRows(res.data.result);
            }).catch((error)=>{
                console.log(error.message);
            });
        } catch(error){
            console.error(error.message);
        }
    };
    
    //DataGrid에서 row 선택 시 
    function onSelectedRow(row){
        // console.log("selection:"+row.lastName);
    };

    const onSearchChange = (e) => {
        let {name, value} = e.target;
        setSearch({
            ...search,
            [name] : value==='ALL'?'':value,
        })
        //지점선택 후 기번 가져오기
        // if (name === "storeCd") {
        //     loadComboBoxMachineNo(value);
        //     loadComboBoxBrand(value);
        // }
        console.log(search);
    };
    
    return(
        <div className="pop-container">
            <Box className="contents">
                <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow className="table-row-header">
                                <TableCell className="table-cell-title" >{fni18n('지점')}</TableCell>
                                <TableCell className="table-cell">
                                    <UTextField name="storeCd" defaultValue={params.storeCd} disabled={true}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                                <TableCell className="table-cell">
                                    <UTextField id="machine" name="machId" defaultValue={params.machId} disabled={true}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('일자')}</TableCell>
                                <TableCell colSpan={3} className="table-cell">
                                    <UDatePickers startDate={search.startDate} endDate={search.endDate} onChange={onSearchChange} />
                                 </TableCell>
                                
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="search"></div>
                {/* 테이블 */}
                <UTable columns={columns} rows={rows} />
            </Box>
        </div>
    );
}